import { render } from "./ViewsOrderSubmitted.vue?vue&type=template&id=189be764"
import script from "./ViewsOrderSubmitted.vue?vue&type=script&lang=js"
export * from "./ViewsOrderSubmitted.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__